import { useTranslation } from 'react-i18next';
import { CountriesEnum } from '@/enums/countries';

/**
 * Retrieves the current locale and language based on the i18n configuration.
 * @returns {locale: string, language: string}
 */
export function useCurrentLocaleData() {
	const { i18n } = useTranslation();

	const country = CountriesEnum.find(c => c.locale === i18n.language);
	const locale = country?.locale || 'en';
	const language = country?.languageCode || 'en';

	return {
		locale,
		language,
	};
}
